import { shallowRef } from 'vue'
import type { ToastStatus } from './types'

/** 当前提示的渲染状态。key 区分同 id 不同生命周期，避免旧句柄误关新提示。 */
export interface ToastEntry {
  key: number
  id?: string
  status: ToastStatus
  message: string
}

export const currentToast = shallowRef<ToastEntry | null>(null)
